import { Link } from "react-router-dom";
import { NAV } from "../lib/site";
import Logo from "./Logo";

const Footer = () => (
    <footer className="relative overflow-hidden bg-ink text-ivory">
        <div className="container-x relative pt-20 pb-10">
            <div className="grid gap-14 lg:grid-cols-[1.4fr_1fr_1fr]">
                <div>
                    <Logo dark tagline size={34} />
                    <p className="mt-8 max-w-md text-lg leading-relaxed text-cloud">
                        AI-powered revenue growth, revenue recovery, margin improvement, and cost reduction for established B2B companies.
                    </p>
                    <p className="mt-6 font-mono text-[11px] uppercase tracking-[0.28em] text-vantera">See the business differently</p>
                    <div className="mt-8 flex flex-wrap gap-3">
                        <Link to="/contact" data-testid="footer-cta-primary" className="inline-flex items-center gap-2 rounded-full bg-vantera px-6 py-3 font-display text-sm font-bold text-ink transition-colors duration-300 hover:bg-ivory">
                            Request a Business X-Ray <span aria-hidden="true">→</span>
                        </Link>
                        <Link to="/contact" data-testid="footer-cta-secondary" className="inline-flex items-center rounded-full border border-white/20 px-6 py-3 font-display text-sm font-bold text-ivory transition-colors duration-300 hover:border-vantera hover:text-vantera">
                            Book an Executive Review
                        </Link>
                    </div>
                </div>
                <nav aria-label="Footer">
                    <p className="eyebrow text-cloud">Navigation</p>
                    <ul className="mt-6 space-y-3">
                        {NAV.map((n) => (
                            <li key={n.path}>
                                <Link to={n.path} data-testid={`footer-nav-${n.path === "/" ? "home" : n.path.slice(1)}`} className="text-[15px] text-ivory/85 transition-colors duration-200 hover:text-vantera">
                                    {n.label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </nav>
                <div>
                    <p className="eyebrow text-cloud">The System</p>
                    <ul className="mt-6 space-y-3 text-[15px] text-ivory/85">
                        <li><Link to="/solutions" data-testid="footer-lever-grow" className="transition-colors hover:text-vantera">Grow New Revenue</Link></li>
                        <li><Link to="/solutions" data-testid="footer-lever-recover" className="transition-colors hover:text-vantera">Recover Existing Revenue</Link></li>
                        <li><Link to="/solutions" data-testid="footer-lever-reduce" className="transition-colors hover:text-vantera">Reduce Operating Costs</Link></li>
                        <li><Link to="/business-x-ray" data-testid="footer-xray" className="transition-colors hover:text-vantera">The Business X-Ray</Link></li>
                    </ul>
                    <p className="mt-8 border-l-2 border-vantera/50 pl-4 font-display text-sm font-bold leading-relaxed text-ivory">
                        Build a More Profitable Business. Not Another Campaign.
                    </p>
                </div>
            </div>

            <div className="mt-16 flex flex-col gap-4 border-t border-white/10 pt-8 sm:flex-row sm:items-center sm:justify-between">
                <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-cloud">© {new Date().getFullYear()} Vantera. All rights reserved.</p>
                <div className="flex gap-8">
                    <Link to="/privacy" data-testid="footer-privacy" className="font-mono text-[11px] uppercase tracking-[0.2em] text-cloud transition-colors hover:text-ivory">Privacy Policy</Link>
                    <Link to="/terms" data-testid="footer-terms" className="font-mono text-[11px] uppercase tracking-[0.2em] text-cloud transition-colors hover:text-ivory">Terms of Use</Link>
                </div>
            </div>
        </div>
        <div aria-hidden="true" className="pointer-events-none select-none px-5 pb-2 sm:px-10">
            <p className="text-outline-dark whitespace-nowrap text-center font-display text-[18vw] font-extrabold leading-[0.85] tracking-tightest">VANTERA</p>
        </div>
    </footer>
);

export default Footer;